<div class="loader"></div>
<df-login #login title="Log into your account" (loggedIn)="loggedIn($event)"></df-login>